const validators = {
	checkShouldShowSuscription: data => data.isSuscriptionEnabled,
}

const getCurrentStep = routes => {
	const pathname = window.location.pathname
	return routes.findIndex(route => route.path === pathname) + 1
}

const getRoutesInfoObject = routes =>
	Object.fromEntries(routes.map(route => [route.path, route]))

const getFilteredRoutes = ({ baseRoutes, ...restData }) =>
	baseRoutes.filter(r => {
		const validator = r?.validation ? validators[r.validation] : null

		if (!validator) return true

		return validator(restData)
	})

export const processRoutes = data => {
	const routes = getFilteredRoutes(data)
	const routeNames = routes.map(route => route.path)
	const routesObject = getRoutesInfoObject(routes)
	const currentStep = getCurrentStep(routes)
	const currentRouteName = routesObject[routeNames[currentStep - 1]]?.name ?? ''
	const percentageCompleted = `${(currentStep / routeNames.length) * 100}`

	return {
		routes,
		routeNames,
		routesObject,
		currentStep,
		currentRouteName,
		percentageCompleted,
	}
}
